function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 11H7V13H5V11Z",
  fill: "#C1C6C9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 16H7V18H5V16Z",
  fill: "#C1C6C9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 21H7V23H5V21Z",
  fill: "#C1C6C9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9 11H17V13H9V11Z",
  fill: "#C1C6C9"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9 16H17V18H9V16Z",
  fill: "#C1C6C9"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 18C17.464 18 15 20.464 15 23.5C15 26.536 17.464 29 20.5 29C23.536 29 26 26.536 26 23.5C26 20.464 23.536 18 20.5 18ZM21.919 25.7L20.104 23.885C20.0014 23.7828 19.9422 23.6448 19.939 23.5V20.761C19.939 20.453 20.181 20.211 20.489 20.211C20.797 20.211 21.039 20.453 21.039 20.761V23.28L22.689 24.93C22.7404 24.9804 22.7813 25.0404 22.8093 25.1067C22.8374 25.173 22.852 25.2442 22.8524 25.3161C22.8527 25.3881 22.8388 25.4594 22.8115 25.526C22.7841 25.5925 22.7438 25.653 22.6929 25.7039C22.642 25.7548 22.5815 25.7951 22.515 25.8225C22.4484 25.8498 22.3771 25.8637 22.3051 25.8634C22.2332 25.863 22.162 25.8484 22.0957 25.8203C22.0294 25.7923 21.9694 25.7514 21.919 25.7Z",
  fill: "#FF900D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M9 21H13V23H9V21Z",
  fill: "#C1C6C9"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M2 26V5H5V8H17V5H20V16H22V5C22 4.46957 21.7893 3.96086 21.4142 3.58579C21.0391 3.21071 20.5304 3 20 3H17V2C17 1.46957 16.7893 0.960859 16.4142 0.585786C16.0391 0.210714 15.5304 0 15 0H7C6.46957 0 5.96086 0.210714 5.58579 0.585786C5.21071 0.960859 5 1.46957 5 2V3H2C1.46957 3 0.960859 3.21071 0.585786 3.58579C0.210714 3.96086 0 4.46957 0 5V26C0 26.5304 0.210714 27.0391 0.585786 27.4142C0.960859 27.7893 1.46957 28 2 28H13V26H2ZM7 2H15V6H7V2Z",
  fill: "#C1C6C9"
});

var SvgIconPendingPostGrey = function SvgIconPendingPostGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPendingPostGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_pending_post_grey.2c016988.svg";
export { ForwardRef as ReactComponent };